export const normalizeIngestionMethod = (ingestionMethod: string) => {
    switch (ingestionMethod) {
        case 'fb_messenger':
            return 'Facebook Marketplace';
        case 'inbound-sms':
            return 'Inbound SMS';
        case 'scheduled-resman-email-csv-report':
            return 'Resman Scheduled Email Report';
        default:
            return ingestionMethod.replace(/-/g, ' ') || 'Unknown';
    }
};
